import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { fetch } from '@nrwl/angular';

import * as LocationActions from './pwa-locations.actions';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

import { LocationInterface, LocationInterfaceWithId } from '@sk/sk-interfaces';
import { PwaLocationsService } from '../../_shared/services/locations/pwa-locations.service';


@Injectable()
export class PwaLocationsEffects {
  loadLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActions.loadLocations),
      fetch({
        run: (action) => {
          // Your custom service 'load' logic goes here. For now just return a success action...
          return LocationActions.loadLocationsSuccess({ locations: [] });
        },

        onError: (action, error) => {
          console.error('Error', error);
          return LocationActions.loadLocationsFailure({ error });
        }
      })
    )
  );


  queryLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LocationActions.queryFireStoreLocations),
      switchMap(() => this.locationService.queryStateChangesLocations()),
      mergeMap(actions => actions),
      map(action => {
        if (action.payload.doc.exists) {
          const payload = {
            ...action.payload.doc.data() as LocationInterface,
            id: (action.payload.doc.id) ? action.payload.doc.id : null,
            exists: action.payload.doc.exists
          } as LocationInterfaceWithId;
          // FireStore Events:  'added' | 'removed' | 'modified'
          switch (action.type) {
            case 'added':
              return LocationActions.fromFireStoreAddLocation({ location: payload });
              break;
            case 'removed':
              return LocationActions.fromFireStoreRemoveLocation({ id: payload.id });
              break;
            case 'modified':
              return LocationActions.fromFireStoreModifyLocation({
                location: payload
              });
              break;
          }
        }
      }),
      catchError((error) => {
        return of(LocationActions.queryFireStoreLocationsError({
          error
        }));
      })
    )
  );


  constructor(private actions$: Actions,
              private locationService: PwaLocationsService) {
  }
}
